const c = {
  name: "GlobalRefresh",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M27,13v6h-6v-2h3c-0.9-1.2-2.4-2-4-2c-2.8,0-5,2.2-5,5s2.2,5,5,5c2.4,0,4.4-1.7,4.9-4h2c-0.5,3.4-3.4,6-6.9,6
			c-3.9,0-7-3.1-7-7s3.1-7,7-7c2,0,3.7,0.8,5,2.1V13H27z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20c11,0,20-9,20-20C40,9,31,0,20,0z M4.4,11.1h5.8c-0.7,2.4-1.1,5.1-1.1,8H2
			C2.2,16.1,3,13.4,4.4,11.1z M5.7,9.1c2.1-2.8,5.1-4.9,8.5-6.1c-0.8,0.9-1.5,2-2.1,3.1C11.6,7,11.1,8,10.8,9.1H5.7z M12.2,11.1
			h15.6c0.8,2.6,1.2,5.7,1.2,8.9c0,3.3-0.5,6.4-1.2,9.1H12.2C11.5,26.4,11,23.3,11,20C11,16.7,11.4,13.7,12.2,11.1z M9,21.1
			c0.1,2.9,0.5,5.6,1.2,8H4.4c-1.4-2.4-2.2-5.1-2.4-8H9z M10.8,31.1c0.4,1,0.8,2,1.2,2.8c0.6,1.2,1.3,2.2,2.1,3.1
			c-3.3-1.1-6.3-3.3-8.4-6H10.8z M26.2,33c-1.5,2.8-3.3,4.5-5.2,4.9v-6.8h6.1C26.8,31.7,26.5,32.4,26.2,33z M19,37.9
			c-1.9-0.4-3.7-2.1-5.2-4.9c-0.3-0.6-0.6-1.2-0.9-1.9H19V37.9z M28,33.9c0.5-0.9,0.9-1.8,1.2-2.8h5c-2.1,2.7-5,4.8-8.4,6
			C26.6,36.1,27.3,35.1,28,33.9z M38,21.1c-0.2,2.9-1,5.6-2.4,8h-5.7c0.7-2.4,1.1-5.1,1.2-8H38z M38,19.1h-7c-0.1-2.9-0.5-5.6-1.1-8
			h5.8C37,13.4,37.8,16.1,38,19.1z M12.9,9.1c0.3-0.7,0.6-1.4,0.9-2c1.5-2.8,3.3-4.5,5.2-4.9v6.9H12.9z M21,9.1V2.1
			c1.9,0.4,3.7,2.1,5.2,4.9c0.3,0.6,0.6,1.3,0.9,2H21z M34.3,9.1h-5C28.9,8,28.4,7,28,6.1c-0.6-1.2-1.3-2.2-2.1-3.1
			C29.2,4.1,32.1,6.3,34.3,9.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as GlobalRefresh
};
